export const isHomepageRegex = "^/(?:hosted/)?places(?:/home)?/?$";
